export default "__VITE_ASSET__BJ4JMIQg__"